'use client'

import { Heart16 } from '@vinted/monochrome-icons'
import { Icon, Image } from '@vinted/web-ui'

import { useTracking } from '@marketplace-web/observability/event-tracker-data'
import { getFingerprint } from '@marketplace-web/session-management/audit-util'
import {
  landingPageEvent,
  InfluencerProductCardModel,
  InfluencerLandingPageEvent,
} from '@marketplace-web/marketing-campaigns/marketing-landing-page-data'

const ProductCard = ({ title, thumbnailUrl, productUrl, testId }: InfluencerProductCardModel) => {
  const { track } = useTracking()

  const handleCardClick = async () =>
    track(
      landingPageEvent({
        event: InfluencerLandingPageEvent.ProductCardClick,
        targetDetails: productUrl,
        deviceId: await getFingerprint(),
      }),
    )

  return (
    <article className="influencer__product-card">
      <a href={productUrl} onClick={handleCardClick}>
        <div className="influencer__product-card-image">
          {thumbnailUrl && (
            <Image
              src={thumbnailUrl}
              loading="lazy"
              scaling={Image.Scaling.Cover}
              testId={testId}
            />
          )}
        </div>
        <h3 className="influencer__product-card-title">
          {title}
          <Icon name={Heart16} color="parent" />
        </h3>
      </a>
    </article>
  )
}

export default ProductCard
